import React, { Component } from "react";
import axios from 'axios';
import LoadingIndicatorComponent from "../utils/loadingIndicator";


class BookingDateChoiceComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dates: null,
            data_request_sent: false,
            error: false
        };
        this.scriptAdded = false;
        this.contentRef = React.createRef();
        this.loaderRef = React.createRef();
    }

    componentDidMount() {
        this.getAvailableDatesFromServer();
    }

    componentDidUpdate() {
        if (this.state.dates && !this.state.error && !this.scriptAdded) {
            this.scriptAdded = true;
            const script2 = document.createElement("script");
            script2.src = "script.js";
            script2.async = true;
            script2.onload = () => {
                if (this.contentRef.current) {
                    this.contentRef.current.style.opacity = '1';
                }
                if (this.loaderRef.current) {
                    this.loaderRef.current.style.display = 'none';
                }
            };
            document.body.appendChild(script2);
        }
    }

    getAvailableDatesFromServer(){
        if(!this.state.data_request_sent){
            this.state.data_request_sent = true;
            const { barberChosen } = this.props;
            axios.post('/api/get_free_dates/', { barberChosen })
            .then(response => {

                if(!response.data.error){
                    this.state.dates = response.data.data;
                    this.setState({ dates: response.data.data,  error: false});
                } else {
                    this.state.dates = response.data.data;
                    this.setState({ dates: response.data.data, error: true });
                }
            })
            .catch(error => {
                this.state.dates = [];
                this.setState({ dates: [], error: true });
            });
        }
    }

    getDayPickerClasses(day){
        if(day.popunjen) return "date-picker-date disabled";
        return "date-picker-date";
    }

    getSlobodniTerminiListComponent(day){
        if(day.popunjen) return <p>Nema slobodnih termina za izabrani dan.</p>

        return day.termini.map(termin =>
            <li className={termin[1]=='occupied' ? 'disabled' : ''} key={termin[2]}>
            <button className='hidden_button' name='datum' disabled={termin[1]==='occupied' ? true : false}>
                <a href="#" onClick={() => this.props.onDateChoice(termin[1]==='occupied' ? -1 : termin[2])}>{termin[0]}</a></button>
            </li>
        )
    }

    handleChangeBarber = () => {
        this.props.onChangeBarber();
    }


    render() {

        if (!this.state.dates) {
            return <LoadingIndicatorComponent/>
        }
        if (this.state.error) {
            return (<section className="section-xl bg-periglacial-blue one-screen-page-content text-center">
            <div className="shell">
                <h2>Sajt preopterećen</h2>
                <p className="big">Došlo je do problema u komunikaciji ili je sajt preopterećen. <br/> Molimo Vas da osvežite stranicu, pokušajte ponovo za par minuta ili nam se obratite na <a href='tel:+381628796883'>+381 62 879 6883</a>. </p>
            </div>
            </section>)
        }
        return (
            <React.Fragment>
                <div ref={this.loaderRef}>
                    <LoadingIndicatorComponent/>
                </div>
                <section ref={this.contentRef} style={{opacity: 0, transition: 'opacity 0.3s ease'}}
                         className="section-xl bg-periglacial-blue one-screen-page-content text-center">
                    <div className="shell">
                        <h2>Izaberite datum i vreme</h2>
                        <p className="big"></p>


                        <div className="rd-material-tabs date-picker" data-items="2" data-xs-items="3" data-sm-items="4" data-md-items="5"
                        data-margin="15" data-stage-padding="0" data-sm-stage-padding="30">
                        <div className="rd-material-tabs__list">
                            <ul>
                                {this.state.dates.map(day=><li key={day.dan}>
                                    <a className={this.getDayPickerClasses(day)} href="">
                                        <div className="date-picker-date-text">{day.mesec}</div>
                                        <div className="date-picker-date-number">{day.dan}</div>
                                        <div className="date-picker-date-text">{day.dannedelja}</div>
                                    </a>
                                </li>)}
                            </ul>
                        </div>
                        <div className="rd-material-tabs__container">
                            {this.state.dates.map(day=><div key={day.dan}>
                                <ul className="date-picker-list animated fadeIn">
                                   {this.getSlobodniTerminiListComponent(day)}
                                </ul>
                            </div>)}
                        </div>
                        </div>
                    </div>
                    <button className="btn btn-style-1 btn-white-pickled-bluewood btn-circle btn-shadow" onClick={this.handleChangeBarber}>Nazad na izbor frizera</button>
                    </section>
            </React.Fragment>
      );
    }
}

export default BookingDateChoiceComponent;
